module.exports = __webpack_public_path__ + "img/butternut-squash-risotto.65aa90a0.jpg";